import { Dialog, Text } from '@loadsmart/miranda-react'
import { useAsset } from '../hooks/useAsset'
import { useState } from 'react'
import { useMessage } from '../../hooks/useMessage'

type DeleteAssetDialogProps = {
  isOpen: boolean
  handleClose: () => void
  handleAssetDrawerClose: () => void
  asset: any
  refresh: () => void
}

export function DeleteAssetDialog({
  isOpen,
  handleClose,
  handleAssetDrawerClose,
  asset,
  refresh,
}: DeleteAssetDialogProps) {
  const messenger = useMessage()

  const { deleteObservation } = useAsset({
    onDeleteSuccess: () => {
      messenger.success('Asset deleted')
      handleClose()
      handleAssetDrawerClose()
      refresh()
    },
    onDeleteError: () => {
      messenger.error(new Error('Something went wrong, could not remove asset'))
      setIsLoading(false)
    },
  })

  const [isLoading, setIsLoading] = useState(false)

  const handleDeleteObservation = async (): Promise<void> => {
    setIsLoading(true)
    await deleteObservation(asset.id, asset, {})
    setIsLoading(false)
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} size="small">
      <Dialog.Header>
        <Text variant="heading-md-bold">Delete asset</Text>
        <Dialog.Close />
      </Dialog.Header>

      <Dialog.Body>
        <Text>Are you sure you want to delete this asset?</Text>
        <Text>This action cannot be undone</Text>
        {/* <Layout.Stack>
          <Text>Select which assets from the ingate transaction you would like to delete</Text>

          <Checkbox name="tractor" checked>
            <Text color="color-text-tertiary">Tractor - MNF8172</Text>
          </Checkbox>
          <Checkbox name="tractor" checked>
            <Text color="color-text-tertiary">Chassis - MCCZ640088</Text>
          </Checkbox>
          <Checkbox name="tractor" checked>
            <Text color="color-text-tertiary">Container - TEWU7274035</Text>
          </Checkbox>

          <Text>Are you sure you want to delete the asset? This action cannot be undone.</Text>
        </Layout.Stack> */}
      </Dialog.Body>

      <Dialog.Actions>
        <Dialog.ActionSecondary onClick={handleClose} disabled={isLoading}>
          Cancel
        </Dialog.ActionSecondary>
        <Dialog.ActionPrimary
          variant="danger"
          onClick={handleDeleteObservation}
          disabled={isLoading}
        >
          Delete
        </Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}
